import React, { useEffect, useRef, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import {
  GeneralStyle,
  FormWrapper,
  SectionWrapper,
  Hr,
  IconGuest,
  ContentSelect,
  SelectStyles,
  List,
  TextTitleList,
  ButtonLink,
  CounterTotalUsers,
  OptionWrapper,
} from "./SurveyConfiguration.styled.js";
import { Form, Card, Row, Col } from "react-bootstrap";
import { useLazyQuery, useMutation } from "@apollo/client";
import AsyncSelect from "react-select/async";
import userIcon from "../../assets/svg/users-icon.svg";
import { setStateSurveyConfiguration } from "../../helpers/StateSurveyConfiguration";
import InfiniteScroll from "react-infinite-scroll-component";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import { NotificationManager } from "react-notifications";
import { theme as themeConfig } from "../../themes/themes";
import PointersLine from "../../components/Loaders/PointersLine/PointersLine";
import Tooltip from "@material-ui/core/Tooltip";
import {
  FormControlLabel,
  FormGroup,
  Checkbox,
  IconButton,
} from "@material-ui/core";
import PropTypes from "prop-types";

import {
  ALL_ROLES_BY_LEVEL,
  USERS_IN_ROLE2,
  COUNTRIES_BY_CLIENT,
  USERS_ADVANCE_SEARCH,
  ALL_USERS_AND_GROUPS_IN_SURVEY,
  ALL_RECURRENCE_CONFIGURATION,
  RECURRENCE_CONFIGURATION_BY_ID,
  ALL_LOBS_COUNTRY,
} from "../../GraphQL/Queries.js";
import {
  USERS_SURVEY_ACTIVE_USERS,
  CREATE_USER_SURVEY_GROUP,
  CREATE_RECURRENCE_CONFIGURATION,
  DELETE_RECURRENCE_CONFIGURATION,
} from "../../GraphQL/Mutations";
import {
  getStateLogin,
  getStateLoginComplete,
} from "../../containers/LayoutHome/stateLogin.js";
import moment from "moment";
import {
  format_date_UTC,
  parseISO8601Duration,
  toCamelCaseFirstLetter,
} from "../../util/UtilityFunctions";
import ModalConfirmAction from "../ModalConfirmAction/ModalConfirmAction.jsx";
import ModalRecurrence from "../ModalRecurrence/ModalRecurrence.jsx";
import ModalAdvanceOptions from "../ModalAdvanceOptions/ModalAdvanceOptions.jsx";
import RecurrenceComponent from "../RecurrenceComponent/RecurrenceComponent.jsx";
import ListOfRecurring from "../ListOfRecurring/ListOfRecurring.jsx";

const SurveyConfigurationForm = ({
  surveyNameProp,
  surveyDescriptionProp,
  title,
  idSurvey,
  selectedGuests,
  setSelectedGuests,
  selectedGroups,
  setSelectedGroups,
  OnlyAssigned,
  onlyReviewWithComments,
  Anonymity,
  setAnonymity,
  RandomQuestions,
  setRandomQuestions,
  itsForm,
}) => {
  const location = useLocation();
  const routerPath = location.pathname;
  const rNameInput = useRef(surveyNameProp);
  const rDescriptionInput = useRef(surveyDescriptionProp);
  const rSelectedUsers = useRef();
  const rCountries = useRef();
  const rCities = useRef();
  const rRoles = useRef();
  const rLobs = useRef();
  const rComoNonComo = useRef();
  const user = useMemo(() => getStateLoginComplete(), []);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedGroupsOld, setSelectedGroupsOld] = useState([]);
  const [renderAgain, setRenderAgain] = useState(false);
  const [, setTotalGuests] = useState();
  const [totalUsers, setTotalUsers] = useState();

  const itsIntegrationTpClient = useMemo(() => itsForm != null ? itsForm : routerPath === "/FormsManagement" ? true : false, []);
  const [selectedCountry, setSelectedCountry] = useState();
  const [selectedCity, setSelectedCity] = useState([]);
  const [selectedRole, setSelectedRole] = useState([]);
  const [selectedLob, setSelectedLob] = useState([]);
  const [selectedCountryIds, setSelectedCountryIds] = useState([]);
  const [selectedCityIds, setSelectedCityIds] = useState([]);
  const [selectedRoleIds, setSelectedRoleIds] = useState([]);
  const [selectedComoNonComo, setSelectedComoNonComo] = useState(null);
  const [selectedLobIds, setSelectedLobIds] = useState([]);
  const [showAdvanceOption, setShowAdvanceOption] = useState(false);
  const [showSurveyRecurring, setShowSurveyRecurring] = useState(false);
  const [guestsData, setGuestsData] = useState([]);
  const [allRolesByLevel, setAllRolesByLevel] = useState([]);
  const [allCountries, setAllCountries] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [allLobs, setAllLobs] = useState();
  const [usersAdvanceSearch, setUsersAdvanceSearch] = useState();
  const [createUserSurveyGroup] = useMutation(CREATE_USER_SURVEY_GROUP);
  const clientId = useMemo(() => user.clientId, []);
  const surveyGroups = useMemo(() => [], []);
  const [usersSurveyActiveUsers] = useMutation(USERS_SURVEY_ACTIVE_USERS);
  const [createRecurrenceConfiguration, { loading: loadingCreateRecurrence }] =
    useMutation(CREATE_RECURRENCE_CONFIGURATION);
  const [deleteRecurrenceConfiguration] = useMutation(
    DELETE_RECURRENCE_CONFIGURATION
  );
  const [openDeleteRecurringModal, setOpenDeleteRecurringModal] =
    useState(null);
  const [recurringSurveys, setRecurringSurveys] = useState([]);
  const [repeatEvery, setRepeatEvery] = useState();
  const dateOptions = useMemo(() => [
    { value: 0, label: "Day" },
    { value: 1, label: "Week" },
    { value: 2, label: "Month" },
    { value: 3, label: "Year" },
  ], []);
  const dataButtonDays = useMemo(() => [
    { label: "M", value: "Monday" },
    { label: "T", value: "Tuesday" },
    { label: "W", value: "Wednesday" },
    { label: "T", value: "Thursday" },
    { label: "F", value: "Friday" },
    { label: "S", value: "Saturday" },
    { label: "S", value: "Sunday" },
  ], []);
  const days = useMemo(() => [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ], []);
  const positionOfTheWeek = useMemo(() => [
    "first",
    "second",
    "third",
    "fourth",
    "fifth",
    "sixth",
    "seventh",
  ], []);
  const dateOfToday = useMemo(() => new Date(), []);
  const dayOfToday = useMemo(() => new Date().getDate(), []);
  const dayOfTheMonth = useMemo(() => days[new Date(dateOfToday).getDay()], []);
  const numberWeek = useMemo(() => Math.ceil(new Date(dateOfToday).getDate() / 7), []);
  const optionForMonth = useMemo(() => [
    { value: 0, label: "Monthly on day " + dayOfToday },
    {
      value: 1,
      label:
        "Monthly on the " +
        positionOfTheWeek[numberWeek - 1] +
        " " +
        dayOfTheMonth,
    },
  ], []);
  const [optionForMonthSelected, setOptionForMonthSelected] = useState();
  const [periodRecurring, setPeriodRecurring] = useState();
  const [neverEndRecurring, setNeverEndRecurring] = useState(false);
  const [onStartRecurring, setOnStartRecurring] = useState(null);
  const [onEndRecurring, setOnEndRecurring] = useState(null);
  const dataEndsDate = useMemo(() => [
    { value: "never", label: "Never" },
    { value: "on", label: "On" },
  ], []);
  const [activateRepeatEvery, setActivateRepeatEvery] = useState(false);
  const [onStartTimeRecurring, setOnStartTimeRecurring] = useState(null);
  const [onEndTimeRecurring, setOnEndTimeRecurring] = useState(null);
  const [dataButtonDaysValue, setDataButtonDaysValue] = useState([]);
  const [showUpdateRecurringButton, setShowUpdateRecurringButton] =
    useState(false);
  const [activeEndsRecurring, setActiveEndsRecurring] = useState();
  const [recurrenceConfigurationById, setRecurrenceConfigurationById] =
    useState(null);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [loading, setLoading] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [runQuerySurveysRecurrences] = useLazyQuery(
    ALL_RECURRENCE_CONFIGURATION,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let resultOfAllRecurrenceConfiguration =
          data.allRecurrenceConfiguration.map((element) => {
            return {
              value: element?.idSurvey,
              label: element?.description,
              idRecurrenceConfiguration: element.idRecurrenceConfiguration,
            };
          });
        setRecurringSurveys(resultOfAllRecurrenceConfiguration);
      },
    }
  );

  const [runQueryRecurrenceConfigurationById] = useLazyQuery(
    RECURRENCE_CONFIGURATION_BY_ID,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (data?.recurrenceConfigurationById) {
          if (data?.recurrenceConfigurationById?.repeatEvery !== null) {
            let repeatevery = data?.recurrenceConfigurationById?.repeatEvery;

            setActivateRepeatEvery(true);
            setRepeatEvery(repeatevery);
          }
          if (data?.recurrenceConfigurationById?.period) {
            let period = toCamelCaseFirstLetter(
              data?.recurrenceConfigurationById?.period
            );

            setPeriodRecurring(period);
          }
          if (data?.recurrenceConfigurationById?.repeatOptions) {
            let dataButtonOptionValue = JSON.parse(
              data?.recurrenceConfigurationById?.repeatOptions
            );

            if (dataButtonOptionValue?.dayOfWeek !== null) {
              let dayOfWeekArr = dataButtonDays.filter((e) => {
                return dataButtonOptionValue?.dayOfWeek.includes(e.value);
              });
              setDataButtonDaysValue(dayOfWeekArr);
            } else if (dataButtonOptionValue?.dayOfMonth !== null) {
              setOptionForMonthSelected({
                value: 0,
                label:
                  "Monthly on day " +
                  dataButtonDays[dataButtonOptionValue?.dayOfMonth[0]]?.value,
              });
            } else if (dataButtonOptionValue?.nWeekDay !== null) {
              setOptionForMonthSelected({
                value: 1,
                label:
                  "Monthly on the " +
                  positionOfTheWeek[
                  dataButtonOptionValue?.nWeekDay[0]?.week - 1
                  ] +
                  " " +
                  dataButtonOptionValue?.nWeekDay[0]?.day,
              });
            }
          }
          if (data?.recurrenceConfigurationById?.startOn !== null) {
            let starton = moment(
              data?.recurrenceConfigurationById?.startOn,
              "YYYY-MM-DD"
            ).format("YYYY-MM-DD");
            let utcStartDate = new Date(
              data?.recurrenceConfigurationById?.startOn
            );
            let startDate = new Date();
            if (data?.recurrenceConfigurationById?.startTime !== null) {
              let starthours = parseISO8601Duration(
                data?.recurrenceConfigurationById?.startTime
              ).hours;
              let startminutes = parseISO8601Duration(
                data?.recurrenceConfigurationById?.startTime
              ).minutes;
              let startResultMinutes =
                startminutes > 9
                  ? startminutes.toString()
                  : "0" + startminutes.toString();
              let startResultHours =
                starthours > 9
                  ? starthours.toString()
                  : "0" + starthours.toString();
              let starttime = moment(
                startResultHours + ":" + startResultMinutes
              )._i;
              setActiveEndsRecurring("on");
              utcStartDate.setUTCHours(startResultHours);
              utcStartDate.setUTCMinutes(startResultMinutes);
              startDate.setUTCDate(utcStartDate.getUTCDate());
              startDate.setUTCMonth(utcStartDate.getUTCMonth());
              startDate.setUTCFullYear(utcStartDate.getUTCFullYear());
              startDate.setUTCHours(utcStartDate.getUTCHours());
              startDate.setUTCMinutes(utcStartDate.getUTCMinutes());
              starton = moment(startDate).format("YYYY-MM-DD");
              startminutes = startDate.getMinutes();
              starthours = startDate.getHours();
              startResultMinutes =
                startminutes > 9
                  ? startminutes.toString()
                  : "0" + startminutes.toString();
              startResultHours =
                starthours > 9
                  ? starthours.toString()
                  : "0" + starthours.toString();
              starttime = moment(
                startResultHours + ":" + startResultMinutes
              )._i;
              setOnStartRecurring(starton);
              setOnStartTimeRecurring(starttime);
            }
          }
          if (data?.recurrenceConfigurationById?.endOn !== null) {
            let endon = moment(
              data?.recurrenceConfigurationById?.endOn,
              "YYYY-MM-DD"
            ).format("YYYY-MM-DD");
            let utcEndDate = new Date(data?.recurrenceConfigurationById?.endOn);
            let endDate = new Date();
            if (data?.recurrenceConfigurationById?.endTime !== null) {
              let endhours = parseISO8601Duration(
                data?.recurrenceConfigurationById?.endTime
              ).hours;
              let endminutes = parseISO8601Duration(
                data?.recurrenceConfigurationById?.endTime
              ).minutes;
              let endResultMinutes =
                endminutes > 9
                  ? endminutes.toString()
                  : "0" + endminutes.toString();
              let endResultHours =
                endhours > 9 ? endhours.toString() : "0" + endhours.toString();
              let endtime = moment(endResultHours + ":" + endResultMinutes)._i;
              setActiveEndsRecurring("on");
              utcEndDate.setUTCHours(endhours);
              utcEndDate.setUTCMinutes(endResultMinutes);
              endDate.setUTCDate(utcEndDate.getUTCDate());
              endDate.setUTCMonth(utcEndDate.getUTCMonth());
              endDate.setUTCFullYear(utcEndDate.getUTCFullYear());
              endDate.setUTCHours(utcEndDate.getUTCHours());
              endDate.setUTCMinutes(utcEndDate.getUTCMinutes());
              endon = moment(endDate).format("YYYY-MM-DD");
              endminutes = endDate.getMinutes();
              endhours = endDate.getHours();
              endResultMinutes =
                endminutes > 9
                  ? endminutes.toString()
                  : "0" + endminutes.toString();
              endResultHours =
                endhours > 9 ? endhours.toString() : "0" + endhours.toString();
              endtime = moment(endResultHours + ":" + endResultMinutes)._i;
              setOnEndTimeRecurring(endtime);
              setOnEndRecurring(endon);
            }
          }
          if (data?.recurrenceConfigurationById?.endOn === null) {
            setActiveEndsRecurring("never");
            setNeverEndRecurring(true);
          }
          if (data?.recurrenceConfigurationById?.idRecurrenceConfiguration) {
            let idrecurrenceconfiguration =
              data?.recurrenceConfigurationById?.idRecurrenceConfiguration;

            setRecurrenceConfigurationById(idrecurrenceconfiguration);
          }

          setShowSurveyRecurring(true);
          setShowUpdateRecurringButton(true);
        } else {
          NotificationManager.warning(
            "This recurrence doesn't exist in this survey",
            "",
            5000
          );
        }
      },
    }
  );
  const [runQueryCountry] = useLazyQuery(COUNTRIES_BY_CLIENT, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfAllCountries = data.countryLocationList.map((element) => {
        return {
          ...element,
          value: element?.countryId,
          label: element?.countryName,
        };
      });
      setAllCountries(resultOfAllCountries);
    },
  });

  const [runQueryLobsByCountry] = useLazyQuery(ALL_LOBS_COUNTRY, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfAllLobs = data.lobsListByCountry.map((element) => {
        return {
          value: element?.lobId,
          label: element?.lobName,
        };
      });
      setAllLobs(resultOfAllLobs);
    },
  });
  const [runQueryUsersAdvanceSearch, { loading: loadingUsersOfAdvanceSearch }] =
    useLazyQuery(USERS_ADVANCE_SEARCH, {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let resultOfUsersAdvanceSearch = data?.userListAdvancedSearch?.map?.(
          (element) => {
            return element;
          }
        );
        setUsersAdvanceSearch(resultOfUsersAdvanceSearch);
      },
    });
  const [
    runQueryRolesByLevel,
    { error: errorRoleByLevel, loading: loadingRoleByLevel },
  ] = useLazyQuery(ALL_ROLES_BY_LEVEL, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfAllRolesByLevel = data.rolesByUserProfile.map((element) => {
        return {
          value: element?.roleId,
          label: element?.friendlyDescription,
          roleLevel: element?.roleLevel,
        };
      });
      setAllRolesByLevel(resultOfAllRolesByLevel);
    },
  });

  const [runQueryUsersInRole2, { error }] = useLazyQuery(USERS_IN_ROLE2, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      const usersInRole2 = data.userListAdvancedSearch.map((element) => ({
        value: element?.userId,
        label: `${element?.userFirstName} ${element?.userLastName} - ${element?.userCcms}`,
        firstName: element?.userFirstName,
        lastName: element?.userLastName,
        emailAddress: element?.userTpId,
        ccmsid: element?.userCcms,
        ccmsuser: element?.userCcms,
      }));

      if (usersInRole2.length === 0) {
        setHasMoreData(false);
      }
      setGuestsData((prevData) => {
        const newData = usersInRole2.filter(user =>
          !prevData.some((existingUser) => existingUser.value === user.value)
        );
        return [...prevData, ...newData];
      });
      setLoading(false);
    },
  });

  const [runQueryUsersAndGroups] = useLazyQuery(
    ALL_USERS_AND_GROUPS_IN_SURVEY,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let resultOfAllUsernames = data.allUsersAndGroupsInSurvey.userNames.map(
          (element, i) => {
            return {
              label: element,
              value: data?.allUsersAndGroupsInSurvey?.userIds[i],
            };
          }
        );
        let resultOfAllGroupnames = data.allUsersAndGroupsInSurvey.groups.map(
          (element) => {
            return {
              label: element?.name,
              count: element?.countCient,
              idGroup: element?.code,
            };
          }
        );
        setSelectedUsers(resultOfAllUsernames);
        setSelectedGroupsOld(resultOfAllGroupnames);
        setTotalUsers(data.allUsersAndGroupsInSurvey.totalUsers);
        setTotalGuests(data.allUsersAndGroupsInSurvey.totalUsers);
      },
    }
  );

  useEffect(() => {
    if (clientId) {
      runQueryCountry({
        variables: { clientId: clientId },
        context: { clientName: "LinkUsers" },
      });
    }

    if (user.roleId) {
      runQueryRolesByLevel({
        variables: { roleId: user.roleId },
        context: { clientName: "LinkUsers" },
      })
        .then((response) => {
          console.log("response roles by level", response);
        })
        .catch((error) => {
          let errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }

    if (idSurvey) {
      runQueryUsersAndGroups({
        variables: { surveyId: idSurvey },
      });
    }

    runQuerySurveysRecurrences({
      variables: { idSurvey: idSurvey },
    });
  }, []);

  useEffect(() => {
    if (allRolesByLevel.length > 0) {
      setLoading(true);
      setGuestsData([]); // Reiniciar los datos al iniciar una nueva consulta
      setHasMoreData(true); // Reiniciar hasMoreData al iniciar una nueva consulta

      loadMoreOptions();
    }
  }, [allRolesByLevel]); // Ejecutar solo cuando allRolesByLevel cambie

  useEffect(() => {
    if (surveyNameProp) {
      rNameInput.current.value = surveyNameProp || "";
      setStateSurveyConfiguration(rNameInput.current.value, "surveyName");
    }
    if (surveyDescriptionProp) {
      rDescriptionInput.current.value = surveyDescriptionProp || "";
      setStateSurveyConfiguration(
        rDescriptionInput.current.value,
        "surveyDescription"
      );
    }
  }, [surveyNameProp, surveyDescriptionProp]);

  useEffect(() => {
    if (periodRecurring !== "Week") {
      setDataButtonDaysValue([]);
    }
  }, [periodRecurring]);

  useEffect(() => {
    if (onEndRecurring !== null) {
      setNeverEndRecurring(false);
    } else {
      setNeverEndRecurring(true);
    }
  }, [onEndRecurring]);

  useEffect(() => {
    if (neverEndRecurring === true) {
      setOnEndRecurring(null);
    }
  }, [neverEndRecurring, setNeverEndRecurring]);

  useEffect(() => {
    handleUsersAdvanceSearch();
  }, [
    selectedCountryIds,
    selectedCityIds,
    selectedRoleIds,
    selectedLobIds,
    selectedComoNonComo,
  ]);

  useEffect(() => {
    if (selectedGuests.length) {
      let selection = selectedUsers;
      selectedGuests.map((element) => {
        if (selection.findIndex((f) => f.label === element.label) === -1) {
          selection.push(element);
        }
      });
      setSelectedGuests(selection);
    } else {
      setSelectedGuests(selectedUsers);
    }
  }, [selectedUsers]);

  useEffect(() => {
    if (selectedGroups.length) {
      let selection = selectedGroupsOld;
      selectedGroups.map((element) => {
        if (selection.findIndex((f) => f.label === element.label) === -1) {
          selection.push(element);
        }
      });
      setSelectedGroups(selection);
    } else setSelectedGroups(selectedGroupsOld);
  }, [selectedGroupsOld]);

  useEffect(() => {
    if (activeEndsRecurring === "never") {
      setNeverEndRecurring(true);
    } else {
      setNeverEndRecurring(false);
    }
  }, [activeEndsRecurring]);

  useEffect(() => {
    if (activateRepeatEvery === false) {
      setRepeatEvery();
      setPeriodRecurring();
    }
  }, [activateRepeatEvery]);

  let handleUsersAdvanceSearch = () => {
    if (selectedComoNonComo !== null) {
      runQueryUsersAdvanceSearch({
        variables: {
          clientId: clientId,
          countries: selectedCountryIds,
          cities: selectedCityIds,
          roles: selectedRoleIds,
          lobs: selectedLobIds,
          isCoMoUser: selectedComoNonComo,
        },
        context: { clientName: "LinkUsers" },
      });
    } else {
      runQueryUsersAdvanceSearch({
        variables: {
          clientId: clientId,
          countries: selectedCountryIds,
          cities: selectedCityIds,
          roles: selectedRoleIds,
          lobs: selectedLobIds,
        },
        context: { clientName: "LinkUsers" },
      });
    }
  };
  let nameHandler = () => {
    setStateSurveyConfiguration(rNameInput.current.value, "surveyName");
  };
  let descriptionHandler = () => {
    setStateSurveyConfiguration(
      rDescriptionInput.current.value,
      "surveyDescription"
    );
  };
  let handleChangeSelectUsers = (items) => {
    setStateSurveyConfiguration(items, "SelectedUsers");

    let totalWithSelectionOfUsers = totalUsers + items.length;
    if (items.length > 0) {
      let selection = selectedUsers;
      items.map((element) => {
        if (selection.findIndex((f) => f.label === element.label) === -1) {
          selection.push(element);
        }
      });
      setSelectedGuests(selection);
      setTotalGuests(totalWithSelectionOfUsers);
    } else {
      setSelectedGuests([]);
      setTotalGuests(totalUsers);
    }
  };

  const getCityForCountry = (id) => {
    let selectedCountry = allCountries.filter(
      (e) => e.countryId === parseInt(id)
    );
    if (selectedCountry?.length > 0) {
      let citiesArr = selectedCountry[0].cities.map((e) => {
        return {
          ...e,
          value: e.cityId,
          label: e.cityName,
        };
      });
      setAllCities(citiesArr);
    } else {
      setAllCities([]);
    }
  };

  let handleChangeSelectCountry = (item) => {
    setSelectedCountry(item);
    setSelectedCountryIds(item.value);
    if (item?.value) {
      getCityForCountry(item.value);
      runQueryLobsByCountry({
        variables: { countryId: item.value, searchBy: "" },
        context: { clientName: "LinkUsers" },
      });
    } else {
      setAllCities([]);
    }
    rCities.current.state.ariaSelection = [];
    rCities.current.clearValue();
    setSelectedCity([]);
    setSelectedCityIds([]);
  };

  let handleChangeSelectCity = (items) => {
    let selectedItems = items.map((element) => {
      return element.value;
    });
    setSelectedCity(items);
    setSelectedCityIds(selectedItems);
  };

  let handleChangeSelectRole = (items) => {
    let selectedItems = items.map((element) => {
      return element.value;
    });
    setSelectedRole(items);
    setSelectedRoleIds(selectedItems);
  };

  let handleChangeSelectLob = (items) => {
    let selectedItems = items.map((element) => {
      return element.value;
    });
    setSelectedLob(items);
    setSelectedLobIds(selectedItems);
  };

  let handleChangeComoNoComo = (item) => {
    if (item.value === 1) {
      setSelectedComoNonComo(true);
    } else if (item.value === 2) {
      setSelectedComoNonComo(false);
    } else {
      setSelectedComoNonComo(null);
    }
  };

  let closeAdvanceSearch = () => {
    setShowAdvanceOption(false);
  };

  let closeSurveyRecurring = () => {
    setShowSurveyRecurring(false);
    cleanSurveyRecurring();
  };

  let cleanSurveyRecurring = () => {
    setActiveEndsRecurring();
    setRepeatEvery();
    setPeriodRecurring();
    setDataButtonDaysValue([]);
    setNeverEndRecurring(false);
    setActivateRepeatEvery(false);
    setOnStartRecurring(null);
    setOnStartTimeRecurring(null);
    setOnEndRecurring(null);
    setOnEndTimeRecurring(null);
  };

  let deleteRecurring = (item) => {
    let errorMessage = "";
    deleteRecurrenceConfiguration({
      variables: {
        recurrenceConfigurationId: item.idRecurrenceConfiguration,
      },
    })
      .then((response) => {
        if (errorMessage === "") {
          let allRecurringSurveys = [...recurringSurveys];
          allRecurringSurveys.splice(
            allRecurringSurveys.findIndex(
              (f) =>
                f.recurrenceConfigurationId === item.recurrenceConfigurationId
            ),
            1
          );
          setRecurringSurveys(allRecurringSurveys);
          setRenderAgain(!renderAgain);
          NotificationManager.success(
            "The recurring survey has been removed",
            "",
            5000
          );
          setOpenDeleteRecurringModal(null);
        } else {
          NotificationManager.error(errorMessage, "", 5000);
        }
      })
      .catch((error) => {
        errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let cleanSelects = () => {
    setSelectedCountry();
    setSelectedCity([]);
    setSelectedRole([]);
    setSelectedLob([]);
    setUsersAdvanceSearch([]);

    setSelectedCountryIds([]);
    setSelectedCityIds([]);
    setSelectedRoleIds([]);
    setSelectedLobIds([]);

    setAllCities([]);
  };

  let handlePeriodRecurring = (periodRecurring) => {
    switch (periodRecurring) {
      case "Day":
        return "DAY";
      case "Week":
        return "WEEK";
      case "Month":
        return "MONTH";
      case "Year":
        return "YEAR";
      default:
        return "";
    }
  };

  let createRecurringSurvey = () => {
    let errorMessage = "";
    let daysOfRepeatSelected =
      "" +
      dataButtonDaysValue.map((element) => {
        return element.value;
      });
    let daysOfRepeatSelectedArray = dataButtonDaysValue.map((element) => {
      return element.value;
    });
    let labelOfRecurring = "";
    if (neverEndRecurring === true && onEndRecurring === null) {
      if (onStartTimeRecurring !== null) {
        labelOfRecurring =
          "Starts on " +
          moment(onStartRecurring)._i +
          " on " +
          moment(onStartTimeRecurring)._i +
          ", and " +
          (neverEndRecurring === true ? "never end" : "");
      } else if (daysOfRepeatSelected.length && periodRecurring !== null) {
        labelOfRecurring =
          periodRecurring +
          " on " +
          daysOfRepeatSelected +
          ", " +
          (neverEndRecurring === true ? "never end" : "");
      } else if (periodRecurring !== null && repeatEvery !== null) {
        labelOfRecurring =
          "Every " +
          periodRecurring +
          "" +
          ", on " +
          repeatEvery +
          " times" +
          ", " +
          (neverEndRecurring === true
            ? "never end until " + repeatEvery + " times"
            : "");
      }
    } else if (
      onStartTimeRecurring !== null &&
      onEndRecurring !== null &&
      onEndTimeRecurring !== null &&
      activeEndsRecurring === "on"
    ) {
      labelOfRecurring =
        (periodRecurring || "Starts") +
        " on " +
        moment(onStartRecurring)._i +
        " on " +
        moment(onStartTimeRecurring)._i +
        ", " +
        (onEndRecurring
          ? `and until this date ${moment(onEndRecurring)._i} end on ` +
          moment(onEndTimeRecurring)._i
          : "");
    }
    let startHH = onStartTimeRecurring
      ? new Date(moment(onStartTimeRecurring._i, "hours")._d)
        .getHours()
        .toString()
      : "";
    let startSS = onStartTimeRecurring
      ? new Date(moment(onStartTimeRecurring._i, "hours")._d)
        .getSeconds()
        .toString()
      : "";
    let ISOStartDate = moment(onStartRecurring, "YYYY-MM-DD").toISOString();
    let startDate = new Date(ISOStartDate);
    startDate.setHours(startHH);
    startDate.setMinutes(startSS);
    let utcStartDateObj = format_date_UTC(startDate);
    startHH = utcStartDateObj.UTC_HOUR;
    startSS = utcStartDateObj.UTC_MINUTE;
    let startDateUTC = utcStartDateObj.UTC_DATE_FORMAT;
    let endHH = onEndTimeRecurring
      ? new Date(moment(onEndTimeRecurring._i, "hours")._d)
        .getHours()
        .toString()
      : "";
    let endSS = onEndTimeRecurring
      ? new Date(moment(onEndTimeRecurring._i, "hours")._d)
        .getSeconds()
        .toString()
      : "";
    let ISOEndDate = moment(onEndRecurring, "YYYY-MM-DD").toISOString();
    let endDate = new Date(ISOEndDate);
    endDate.setHours(endHH);
    endDate.setMinutes(endSS);
    let utcEndDateObj = format_date_UTC(endDate);
    endHH = utcEndDateObj.UTC_HOUR;
    endSS = utcEndDateObj.UTC_MINUTE;
    let endDateUTC = utcEndDateObj.UTC_DATE_FORMAT;
    let startTime = onStartTimeRecurring
      ? "PT" + startHH + "H" + startSS + "M"
      : "";
    let endTime = onEndTimeRecurring ? "PT" + endHH + "H" + endSS + "M" : "";
    let repeatOptions = JSON.stringify({
      dayOfWeek:
        periodRecurring === "Week"
          ? daysOfRepeatSelectedArray.length > 0
            ? daysOfRepeatSelectedArray
            : []
          : [],
      dayOfMonth:
        periodRecurring === "Month" && optionForMonthSelected?.value === 0
          ? [dayOfToday]
          : [],
      nWeekDay:
        periodRecurring === "Month" && optionForMonthSelected?.value === 1
          ? [{ week: numberWeek, day: dayOfTheMonth }]
          : [],
    });
    let period = handlePeriodRecurring(periodRecurring);
    if (
      (idSurvey &&
        user?.userName &&
        labelOfRecurring &&
        onStartRecurring &&
        onStartTimeRecurring &&
        !neverEndRecurring &&
        onEndTimeRecurring &&
        onEndRecurring &&
        !activateRepeatEvery) ||
      (idSurvey &&
        user?.userName &&
        labelOfRecurring &&
        onStartRecurring &&
        onStartTimeRecurring &&
        !neverEndRecurring &&
        onEndTimeRecurring &&
        onEndRecurring &&
        activateRepeatEvery &&
        period &&
        repeatEvery &&
        repeatOptions) ||
      (idSurvey &&
        user?.userName &&
        labelOfRecurring &&
        onStartRecurring &&
        onStartTimeRecurring &&
        neverEndRecurring &&
        activateRepeatEvery &&
        period &&
        repeatEvery &&
        repeatOptions) ||
      (idSurvey &&
        user?.userName &&
        labelOfRecurring &&
        onStartRecurring &&
        onStartTimeRecurring &&
        neverEndRecurring &&
        !activateRepeatEvery)
    ) {
      createRecurrenceConfiguration({
        variables: {
          recurrenceConfigurationModel: {
            idSurvey: idSurvey,
            description: labelOfRecurring,
            repeatEvery: activateRepeatEvery ? parseInt(repeatEvery) : null,
            period: activateRepeatEvery ? period : null,
            repeatOptions: repeatOptions || null,
            startOn: startDateUTC
              ? moment(startDateUTC).format("YYYY-MM-DD")
              : null,
            startTime: onStartTimeRecurring ? startTime : null,
            endOn:
              onEndRecurring && !neverEndRecurring
                ? moment(endDateUTC).format("YYYY-MM-DD")
                : null,
            endTime:
              onEndTimeRecurring && !neverEndRecurring
                ? endTime
                : "PT23H59M59S",
            createUser: user.userName,
          },
        },
      })
        .then((response) => {
          if (
            errorMessage === "" &&
            response.data.createRecurrenceConfiguration !== -1
          ) {
            closeSurveyRecurring();
            NotificationManager.success(
              "The survey recurrence has been created",
              "",
              5000
            );
            runQuerySurveysRecurrences({
              variables: { idSurvey: idSurvey },
            });
          } else {
            NotificationManager.warning(
              "Something is wrong in your fields, try again.",
              "",
              5000
            );
          }
        })
        .catch((error) => {
          errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      NotificationManager.warning(
        "These fields are required for create a recurrence",
        "",
        5000
      );
    }
  };

  let updateRecurringSurvey = () => {
    let errorMessage = "";
    let daysOfRepeatSelected =
      "" +
      dataButtonDaysValue.map((element) => {
        return element.value;
      });
    let daysOfRepeatSelectedArray = dataButtonDaysValue.map((element) => {
      return element.value;
    });
    let labelOfRecurring = "";
    if (neverEndRecurring === true && onEndRecurring === null) {
      if (onStartTimeRecurring !== null) {
        labelOfRecurring =
          "Starts on " +
          moment(onStartRecurring)._i +
          " on " +
          moment(onStartTimeRecurring)._i +
          ", and " +
          (neverEndRecurring === true ? "never end" : "");
      } else if (
        daysOfRepeatSelected.length &&
        periodRecurring !== null &&
        periodRecurring !== ""
      ) {
        labelOfRecurring =
          periodRecurring +
          " on " +
          daysOfRepeatSelected +
          ", " +
          (neverEndRecurring === true ? "never end" : "");
      } else if (
        periodRecurring !== null &&
        periodRecurring !== "" &&
        repeatEvery !== null
      ) {
        labelOfRecurring =
          "Every " +
          periodRecurring +
          "" +
          ", on " +
          repeatEvery +
          " times" +
          ", " +
          (neverEndRecurring === true
            ? "never end until " + repeatEvery + " times"
            : "");
      }
    } else if (
      onStartTimeRecurring !== null &&
      onEndRecurring !== null &&
      onEndTimeRecurring !== null &&
      activeEndsRecurring === "on"
    ) {
      labelOfRecurring =
        (periodRecurring || "Starts") +
        " on " +
        moment(onStartRecurring)._i +
        " on " +
        moment(onStartTimeRecurring)._i +
        ", " +
        (onEndRecurring
          ? `and until this date ${moment(onEndRecurring)._i} end on ` +
          moment(onEndTimeRecurring)._i
          : "");
    }
    let startHH = onStartTimeRecurring
      ? new Date(
        moment(
          onStartTimeRecurring._i !== undefined
            ? onStartTimeRecurring._i
            : onStartTimeRecurring,
          "hours"
        )._d
      )
        .getHours()
        .toString()
      : "";
    let startSS = onStartTimeRecurring
      ? new Date(
        moment(
          onStartTimeRecurring._i !== undefined
            ? onStartTimeRecurring._i
            : onStartTimeRecurring,
          "hours"
        )._d
      )
        .getSeconds()
        .toString()
      : "";
    let ISOStartDate = moment(onStartRecurring, "YYYY-MM-DD").toISOString();
    let startDate = new Date(ISOStartDate);
    startDate.setHours(startHH);
    startDate.setMinutes(startSS);
    let utcStartDateObj = format_date_UTC(startDate);
    startHH = utcStartDateObj.UTC_HOUR;
    startSS = utcStartDateObj.UTC_MINUTE;
    let startDateUTC = utcStartDateObj.UTC_DATE_FORMAT;
    let endHH = onEndTimeRecurring
      ? new Date(
        moment(
          onEndTimeRecurring._i !== undefined
            ? onEndTimeRecurring._i
            : onEndTimeRecurring,
          "hours"
        )._d
      )
        .getHours()
        .toString()
      : "";
    let endSS = onEndTimeRecurring
      ? new Date(
        moment(
          onEndTimeRecurring._i !== undefined
            ? onEndTimeRecurring._i
            : onEndTimeRecurring,
          "hours"
        )._d
      )
        .getSeconds()
        .toString()
      : "";
    let ISOSEndDate = moment(onEndRecurring, "YYYY-MM-DD").toISOString();
    let endDate = new Date(ISOSEndDate);
    endDate.setHours(endHH);
    endDate.setMinutes(endSS);
    let utcEndDateObj = format_date_UTC(endDate);
    endHH = utcEndDateObj.UTC_HOUR;
    endSS = utcEndDateObj.UTC_MINUTE;
    let endDateUTC = utcEndDateObj.UTC_DATE_FORMAT;
    let startTime = onStartTimeRecurring
      ? "PT" + startHH + "H" + startSS + "M"
      : "";
    let endTime = onEndTimeRecurring ? "PT" + endHH + "H" + endSS + "M" : "";
    let repeatOptions = JSON.stringify({
      dayOfWeek:
        periodRecurring === "Week"
          ? daysOfRepeatSelectedArray.length > 0
            ? daysOfRepeatSelectedArray
            : []
          : [],
      dayOfMonth:
        periodRecurring === "Month" && optionForMonthSelected?.value === 0
          ? [dayOfToday]
          : [],
      nWeekDay:
        periodRecurring === "Month" && optionForMonthSelected?.value === 1
          ? [{ week: numberWeek, day: dayOfTheMonth }]
          : [],
    });
    let period = handlePeriodRecurring(periodRecurring);
    if (
      (idSurvey &&
        user?.userName &&
        recurrenceConfigurationById &&
        labelOfRecurring &&
        onStartRecurring &&
        onStartTimeRecurring &&
        !neverEndRecurring &&
        onEndTimeRecurring &&
        onEndRecurring &&
        !activateRepeatEvery) ||
      (idSurvey &&
        user?.userName &&
        recurrenceConfigurationById &&
        labelOfRecurring &&
        onStartRecurring &&
        onStartTimeRecurring &&
        !neverEndRecurring &&
        onEndTimeRecurring &&
        onEndRecurring &&
        activateRepeatEvery &&
        period &&
        repeatEvery &&
        repeatOptions) ||
      (idSurvey &&
        user?.userName &&
        recurrenceConfigurationById &&
        labelOfRecurring &&
        onStartRecurring &&
        onStartTimeRecurring &&
        neverEndRecurring &&
        activateRepeatEvery &&
        period &&
        repeatEvery &&
        repeatOptions) ||
      (idSurvey &&
        user?.userName &&
        recurrenceConfigurationById &&
        labelOfRecurring &&
        onStartRecurring &&
        onStartTimeRecurring &&
        neverEndRecurring &&
        !activateRepeatEvery)
    ) {
      createRecurrenceConfiguration({
        variables: {
          recurrenceConfigurationModel: {
            idSurvey: idSurvey,
            idRecurrenceConfiguration: recurrenceConfigurationById,
            description: labelOfRecurring,
            repeatEvery: activateRepeatEvery ? parseInt(repeatEvery) : null,
            period: activateRepeatEvery ? period : null,
            repeatOptions: repeatOptions || null,
            startOn: onStartRecurring !== null ? startDateUTC : null,
            startTime: onStartTimeRecurring ? startTime : null,
            endOn:
              onEndRecurring !== null && !neverEndRecurring ? endDateUTC : null,
            endTime:
              onEndTimeRecurring && !neverEndRecurring
                ? endTime
                : "PT23H59M59S",
            createUser: user.userName,
          },
        },
      })
        .then((response) => {
          if (
            errorMessage === "" &&
            response.data.createRecurrenceConfiguration !== -1
          ) {
            closeSurveyRecurring();
            NotificationManager.success(
              "The survey recurrence has been created",
              "",
              5000
            );
            runQuerySurveysRecurrences({
              variables: { idSurvey: idSurvey },
            });
          } else {
            NotificationManager.warning(
              "Something is wrong in your fields, try again.",
              "",
              5000
            );
          }
        })
        .catch((error) => {
          errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      NotificationManager.warning(
        "These fields are required for update a recurrence",
        "",
        5000
      );
    }
  };

  let editRecurring = (item) => {
    cleanSurveyRecurring();
    if (item.idRecurrenceConfiguration) {
      runQueryRecurrenceConfigurationById({
        variables: {
          recurrenceConfigurationId: item.idRecurrenceConfiguration,
        },
      });
    } else {
      NotificationManager.warning(
        "This recurrence doesn't exist in this survey",
        "",
        5000
      );
    }
  };

  let createGroup = () => {
    let errorMessage = "";

    let countrySelected = selectedCountry ? selectedCountry?.label + " " : "";
    let citiesSelected = selectedCity.reduce((acc, current) => {
      acc += `${current.label} `;
      return acc;
    }, "");
    let rolesSelected = selectedRole.reduce((acc, current) => {
      acc += `${current.label} `;
      return acc;
    }, "");
    let lobsSelected = selectedLob.reduce((acc, current) => {
      acc += `${current.label} `;
      return acc;
    }, "");

    let foundCountrySimilar = selectedGroups.some(
      (obj) => obj.label.toLowerCase() === countrySelected.toLowerCase()
    );
    let foundCitiesSimilar = selectedGroups.some(
      (obj) => obj.label.toLowerCase() === citiesSelected.toLowerCase()
    );
    let foundRolesSimilar = selectedGroups.some(
      (obj) => obj.label.toLowerCase() === rolesSelected.toLowerCase()
    );
    let foundLobsSimilar = selectedGroups.some(
      (obj) => obj.label.toLowerCase() === lobsSelected.toLowerCase()
    );

    if (
      foundCountrySimilar ||
      foundCitiesSimilar ||
      foundRolesSimilar ||
      foundLobsSimilar
    ) {
      NotificationManager.warning("Value is already selected !!", "", 5000);
    } else {
      createUserSurveyGroup({
        variables: {
          input: {
            userIds: usersAdvanceSearch?.map((e) => e.userId),
            groupName: `${countrySelected + citiesSelected + rolesSelected + lobsSelected
              }`,
            createUser: user.userName,
          },
        },
      })
        .then((response) => {
          surveyGroups.push(response.data.createUserSurveyGroup);
          let nameGroup = selectedGroups;
          nameGroup.push({
            label: `${countrySelected + citiesSelected + rolesSelected + lobsSelected
              }`,
            count: usersAdvanceSearch?.length,
            idGroup: response.data.createUserSurveyGroup,
          });
          console.log(nameGroup)
          setSelectedGroups(nameGroup);

          setStateSurveyConfiguration(surveyGroups, "SurveyGroupIds");
          if (errorMessage === "") {
            closeAdvanceSearch();
          } else {
            NotificationManager.warning(
              "Something is wrong in your fields, try again.",
              "",
              5000
            );
          }
        })
        .catch((error) => {
          errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }

  };

  let removeUserAsigned = (index, label) => {
    usersSurveyActiveUsers({
      variables: {
        activeParameter: false,
        surveyIdParameter: idSurvey,
        emailUser: getStateLogin(),
        usersIdParameter: selectedUsers[index].value,
        surveyGroupIds: [],
      },
    })
      .then((response) => {
        if (response.data.usersSurveyActiveUsers) {
          if (rSelectedUsers.current.state.selectValue) {
            let objremove = rSelectedUsers.current.state.selectValue?.filter(
              (f) => f.value === selectedGuests[index].value
            );
            if (objremove.length) {
              rSelectedUsers.current?.removeValue?.(objremove[0]);
            }
          }
          let dto = selectedGuests;
          dto.splice(index, 1);
          setSelectedGuests([...dto]);
          setRenderAgain(!renderAgain);
          setTotalGuests(dto.length);
          NotificationManager.success("The asign has been removed", "", 5000);
        } else {
          NotificationManager.error("Error 404", "", 5000);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };
  let removeGroupsAsigned = (index, item) => {
    usersSurveyActiveUsers({
      variables: {
        activeParameter: false,
        surveyIdParameter: idSurvey,
        emailUser: getStateLogin(),
        usersIdParameter: [],
        surveyGroupIds: [item.idGroup],
      },
    })
      .then((response) => {
        if (response.data.usersSurveyActiveUsers) {
          let dtosurveyGroups = surveyGroups;
          dtosurveyGroups.splice(
            dtosurveyGroups.findIndex((f) => f == item.idGroup),
            1
          );
          setStateSurveyConfiguration(dtosurveyGroups, "SurveyGroupIds");
          let dto = selectedGroups;
          dto.splice(
            selectedGroups.findIndex((f) => f.idGroup == item.idGroup),
            1
          );
          setSelectedGroups(dto);
          setRenderAgain(!renderAgain);
          //   // setTotalGuests(dto.length)
          NotificationManager.success("The asign has been removed", "", 5000);
        } else {
          NotificationManager.error("Error 404", "", 5000);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const showDeleteRecurringModal = () => {
    return (
      openDeleteRecurringModal && (
        <ModalConfirmAction
          title={"Are you sure to delete the recurrence for this survey?"}
          open={openDeleteRecurringModal}
          setOpen={setOpenDeleteRecurringModal}
          fn={deleteRecurring}
          itsForm={itsForm}
        />
      )
    );
  };

  const modalAdvanceOptions = showAdvanceOption && (
    <ModalAdvanceOptions
      selectedUsers={selectedUsers}
      closeAdvanceSearch={closeAdvanceSearch}
      allCountries={allCountries}
      handleChangeSelectCountry={handleChangeSelectCountry}
      rCountries={rCountries}
      rCities={rCities}
      rRoles={rRoles}
      rLobs={rLobs}
      allCities={allCities}
      handleChangeSelectCity={handleChangeSelectCity}
      loadingRoleByLevel={loadingRoleByLevel}
      errorRoleByLevel={errorRoleByLevel}
      allRolesByLevel={allRolesByLevel}
      handleChangeSelectRole={handleChangeSelectRole}
      allLobs={allLobs}
      handleChangeSelectLob={handleChangeSelectLob}
      loadingUsersOfAdvanceSearch={loadingUsersOfAdvanceSearch}
      usersAdvanceSearch={usersAdvanceSearch}
      createGroup={createGroup}
      handleChangeComoNoComo={handleChangeComoNoComo}
      rComoNonComo={rComoNonComo}
    />
  );

  // Función para cargar más opciones
  const loadMoreOptions = () => {
    if (!hasMoreData || loading) return;  // Evita cargar si ya no hay más datos o si está cargando

    setLoading(true);  // Muestra el estado de carga

    const offset = guestsData.length;  // Usa el tamaño actual de los datos como offset
    const limit = 10;

    const rolesId = allRolesByLevel.map((element) => element.value);  // Obtén los IDs de los roles

    // Ejecuta la consulta para obtener más datos
    runQueryUsersInRole2({
      variables: { rolesId, offset, limit, search: '' },
      context: { clientName: 'LinkUsers' },
    });
  };

  const handleMenuScroll = (event) => {
    const { scrollTop, scrollHeight, clientHeight } = event.currentTarget;
    setScrollPosition(scrollTop);
    if (scrollTop < 50) {
      loadMoreOptions();
    } else if (scrollHeight - scrollTop >= clientHeight && hasMoreData) {
      loadMoreOptions();
    }
  };
  // Función que filtra los datos de invitados basados en la entrada del usuario
  const filterGuestData = (inputValue) => {
    setScrollPosition(0);  // Reinicia el scroll al buscar nuevos datos

    const offset = 0;  // Reinicia el offset para una nueva búsqueda
    const limit = 10;

    const rolesId = allRolesByLevel.map((element) => element.value);  // Obtén los IDs de los roles

    // Ejecuta la consulta para obtener los datos filtrados
    runQueryUsersInRole2({
      variables: { rolesId, offset, limit, search: inputValue.toLowerCase() },
      context: { clientName: 'LinkUsers' },
    });

    // Filtra los datos localmente mientras se obtienen los nuevos resultados
    return guestsData?.filter((i) =>
      i.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  // Promesa que simula el tiempo de respuesta de la búsqueda
  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      setTimeout(() => {
        resolve(filterGuestData(inputValue));  // Devuelve los datos filtrados
      }, 1000);  // Retraso simulado para hacer más fluida la búsqueda
    });

  // Componente que muestra el selector de usuarios
  const showSelectUsers = () => {
    return (
      <ContentSelect users={true} OnlyAssigned={OnlyAssigned}>
        <Form.Label>
          <IconGuest src={userIcon}></IconGuest> Guests
        </Form.Label>
        <AsyncSelect
          className="select-guests"
          placeholder="Type user"
          isMulti
          isDisabled={onlyReviewWithComments}
          ref={rSelectedUsers}
          isLoading={loading}  // Indicador de carga cuando se están cargando datos
          cacheOptions={false}
          loadOptions={promiseOptions}  // Llama a la función de búsqueda cuando el usuario escribe
          defaultOptions={guestsData}  // Datos por defecto
          onMenuScrollToBottom={handleMenuScroll}
          styles={SelectStyles}
          onChange={handleChangeSelectUsers}
          noOptionsMessage={() => 'There is no more users'}  // Mensaje cuando no haya opciones disponibles
        />
        <ButtonLink
          onClick={() => {
            if (!onlyReviewWithComments) {
              cleanSelects();
              setShowAdvanceOption(true);  // Activa la búsqueda avanzada
            }
          }}
          disabled={onlyReviewWithComments}
          className="text-dark text-right"
        >
          Advanced Search
        </ButtonLink>
      </ContentSelect>
    );
  };


  const showTotalUsers = () => {
    let counterTotalUsers = totalUsers;
    // selectedGuests
    return (
      counterTotalUsers > 0 && (
        <Card className="d-flex flex-column-reverse card-flex">
          <Row style={{ width: "100%" }} className="ml-2">
            <Col className="text-center d-flex align-items-md-center" md="8">
              <IconGuest className="mr-2" src={userIcon}></IconGuest> Total
              users:{" "}
              <CounterTotalUsers className="ml-2">
                {counterTotalUsers}
              </CounterTotalUsers>
            </Col>
          </Row>
        </Card>
      )
    );
  };

  const handleDayChange = (e) => {
    let selectedValue = JSON.parse(e.currentTarget.value);
    let removeAlreadySelected = dataButtonDaysValue.filter(
      (d) => d.value !== selectedValue?.value
    );
    if (removeAlreadySelected.length !== dataButtonDaysValue.length) {
      setDataButtonDaysValue([...removeAlreadySelected]);
    } else {
      setDataButtonDaysValue([...dataButtonDaysValue, selectedValue]);
    }
  };

  const modalSurveyRecurring = showSurveyRecurring && (
    <ModalRecurrence
      isEvent={false}
      closeRecurring={closeSurveyRecurring}
      onStartRecurring={onStartRecurring}
      setOnStartRecurring={setOnStartRecurring}
      onStartTimeRecurring={onStartTimeRecurring}
      setOnStartTimeRecurring={setOnStartTimeRecurring}
      loadingCreateRecurrence={loadingCreateRecurrence}
      activateRepeatEvery={activateRepeatEvery}
      setActivateRepeatEvery={setActivateRepeatEvery}
      repeatEvery={repeatEvery}
      setRepeatEvery={setRepeatEvery}
      dateOptions={dateOptions}
      periodRecurring={periodRecurring}
      setPeriodRecurring={setPeriodRecurring}
      dataButtonDays={dataButtonDays}
      dataButtonDaysValue={dataButtonDaysValue}
      handleDayChange={handleDayChange}
      optionForMonth={optionForMonth}
      optionForMonthSelected={optionForMonthSelected}
      setOptionForMonthSelected={setOptionForMonthSelected}
      dataEndsDate={dataEndsDate}
      activeEndsRecurring={activeEndsRecurring}
      setActiveEndsRecurring={setActiveEndsRecurring}
      onEndRecurring={onEndRecurring}
      setOnEndRecurring={setOnEndRecurring}
      onEndTimeRecurring={onEndTimeRecurring}
      setOnEndTimeRecurring={setOnEndTimeRecurring}
      showUpdateRecurringButton={showUpdateRecurringButton}
      createRecurring={createRecurringSurvey}
      updateRecurring={updateRecurringSurvey}
    />
  );

  const surveyRecurring = itsIntegrationTpClient ? (
    <></>
  ) : (
    <RecurrenceComponent
      title={"This is a recurring survey"}
      cleanRecurring={cleanSurveyRecurring}
      setShowUpdateRecurringButton={setShowUpdateRecurringButton}
      setShowRecurring={setShowSurveyRecurring}
      onlyReviewWithComments={onlyReviewWithComments}
    />
  );

  const listOfSurveyRecurring = recurringSurveys.length > 0 && (
    <ListOfRecurring
      list={recurringSurveys}
      editRecurring={editRecurring}
      setOpenDeleteRecurringModal={setOpenDeleteRecurringModal}
    />
  );

  return (
    <GeneralStyle>
      <InfiniteScroll
        dataLength={selectedUsers.length}
        height="100%"
        loader={
          <Row>
            <Col md="12" className="d-flex justify-content-center">
              <PointersLine color={themeConfig.text.primary} />
            </Col>
          </Row>
        }
        className="left-scroll"
      >
        <FormWrapper>
          <SectionWrapper>
            <Form.Label>Survey Name</Form.Label>
            <Form.Control
              placeholder="Add name"
              ref={rNameInput}
              disabled={onlyReviewWithComments}
              type="text"
              onChange={() => nameHandler()}
            />
          </SectionWrapper>
          <SectionWrapper>
            <Form.Label>Description</Form.Label>
            <Form.Control
              placeholder="Add description"
              ref={rDescriptionInput}
              disabled={onlyReviewWithComments}
              type="text"
              onChange={() => descriptionHandler()}
            />
          </SectionWrapper>
          <Hr />
          {error && <option>Error :(</option>}
          {!error && showSelectUsers()}
          <br></br>
          {selectedGuests.length > 0 && !loading && !error && (
            <>
              <Hr />
              <List OnlyAssigned={OnlyAssigned}>
                <TextTitleList className="font-weight-bold">
                  Users
                </TextTitleList>

                {selectedGuests &&
                  selectedGuests.map((item, index) => {
                    return (
                      <Row key={index}>
                        <Col md="8" className="d-flex align-items-center">
                          {index + 1}. {item.label}
                        </Col>
                        <Col md="4" className="d-flex justify-content-center">
                          <Tooltip title="Remove">
                            <IconButton
                              style={{
                                opacity: onlyReviewWithComments ? "0.4" : "1",
                              }}
                              onClick={() => {
                                if (!onlyReviewWithComments) {
                                  removeUserAsigned(index, item.label);
                                }
                              }}
                            >
                              <RemoveCircleOutlineIcon
                                style={{ color: themeConfig.text.primary }}
                              />
                            </IconButton>
                          </Tooltip>
                        </Col>
                      </Row>
                    );
                  })}
              </List>
            </>
          )}

          {selectedUsers.length > 0 || selectedGuests.length > 0 ? (
            <Hr />
          ) : null}

          {selectedGroups.length > 0 && (
            <>
              <Hr />
              <List OnlyAssigned={OnlyAssigned}>
                <TextTitleList className="font-weight-bold">
                  Groups
                </TextTitleList>
                {selectedGroups.map((item, index) => {
                  return (
                    <Row key={index}>
                      <Col md="8" className="d-flex align-items-center">
                        {index + 1}. {item.label}
                      </Col>
                      <Col md="4" className="d-flex justify-content-center">
                        <Tooltip title="Remove">
                          <IconButton
                            style={{
                              opacity: onlyReviewWithComments ? "0.4" : "1",
                            }}
                            onClick={() => {
                              if (!onlyReviewWithComments) {
                                removeGroupsAsigned(index, item);
                              }
                            }}
                          >
                            <RemoveCircleOutlineIcon
                              style={{ color: themeConfig.text.primary }}
                            />
                          </IconButton>
                        </Tooltip>
                      </Col>
                    </Row>
                  );
                })}
              </List>
            </>
          )}
          {!loading && !error ? showTotalUsers() : null}
          {!loading && !error ? <Hr /> : null}
          {!loading && !error ? surveyRecurring : null}

          {!loading && !error ? listOfSurveyRecurring : null}
          {!loading && !error ? <Hr /> : null}
          <OptionWrapper>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    name="enable-anonymity"
                    disabled={onlyReviewWithComments}
                    onChange={(e) => setAnonymity(!Anonymity)}
                    checked={Anonymity}
                  />
                }
                label={
                  itsForm
                    ? "Enable anonymity for this form"
                    : " Enable anonymity for this survey"
                }
              />
            </FormGroup>
          </OptionWrapper>
          <Hr />
          <OptionWrapper>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    name="enable-random"
                    disabled={onlyReviewWithComments}
                    onChange={(e) => setRandomQuestions(!RandomQuestions)}
                    checked={RandomQuestions}
                  />
                }
                label="Activate random questions"
              />
            </FormGroup>
          </OptionWrapper>
          <Hr />
        </FormWrapper>
      </InfiniteScroll>
      {modalAdvanceOptions}
      {modalSurveyRecurring}
      {showDeleteRecurringModal()}
    </GeneralStyle>
  );
};

export default SurveyConfigurationForm;

SurveyConfigurationForm.propTypes = {
  surveyNameProp: PropTypes.any,
  surveyDescriptionProp: PropTypes.any,
  title: PropTypes.string,
  idSurvey: PropTypes.number,
  selectedGuests: PropTypes.array,
  setSelectedGuests: PropTypes.func,
  selectedGroups: PropTypes.array,
  setSelectedGroups: PropTypes.func,
  OnlyAssigned: PropTypes.any,
  onlyReviewWithComments: PropTypes.any,
  Anonymity: PropTypes.bool,
  setAnonymity: PropTypes.func,
  RandomQuestions: PropTypes.bool,
  setRandomQuestions: PropTypes.func,
  itsForm: PropTypes.any,
};
